import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'

export const NavbarBox = styled.div<{$isAuthenticated: boolean}>`
  width: 100%;
  height: 96px;
  display: flex;
  border-bottom: 1px solid ${colors.bksGray80};
  position: fixed;
  box-sizing: border-box;
  background: #fff;
  justify-content: space-between;
  z-index: 10;

  ${({$isAuthenticated}) =>
    $isAuthenticated ? `padding:0 24px;` : `padding-left:24px;`}

  ${theme.breakpoints.down('md')} {
    height: 56px;
    padding: 0 16px;
  }
`

export const LeftBox = styled.div`
  display: flex;
  align-items: center;
`

export const LogoBox = styled.div`
  cursor: pointer;
  && img {
    height: 54px;
  }
  padding-right: 24px;
  border-right: 1px solid ${colors.bksGray80};

  ${theme.breakpoints.down('md')} {
    padding-left: 16px;
    && img {
      height: 44px;
    }

    display: flex;
    align-items: center;

    height: 55px;
  }
`

export const LinksBox = styled.div`
  display: flex;
  gap: 32px;
  padding-left: 40px;

  @media only screen and (max-width: 1050px) {
    gap: 24px;
  }
`

export const StyledLink = styled.a`
  color: ${colors.bksGray80} !important;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: ${colors.bksGray50} !important;
  }
`

export const RightBox = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;

  @media only screen and (max-width: 1050px) {
    gap: 24px;
  }
`

export const SearchBox = styled.div`
  position: relative;
`

export const FloatingIcon = styled.img`
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 9px;
`

export const StyledInput = styled.input`
  width: 200px;
  height: 33px;
  border: 1px solid #dadada;
  border-radius: 25px;
  padding-left: 16px;
  padding-right: 30px;
  box-sizing: border-box;
  font-family: Public Sans;
  color: ${colors.bksGray80};

  &:focus-visible {
    outline: none !important;
  }
`

export const IconsBox = styled.div`
  display: flex;
  gap: 32px;
  height: 100%;
  align-items: center;

  @media only screen and (max-width: 1050px) {
    gap: 24px;
  }

  ${theme.breakpoints.down('md')} {
    gap: 16px;
  }
`

export const Icon = styled.div<{$isActive?: boolean}>`
  display: flex;
  flex-flow: column;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
  align-items: center;

  && img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    color: ${colors.bksGray50} !important;
  }

  ${({$isActive}) =>
    $isActive
      ? `
    color: ${colors.bksGray50} !important;
    text-decoration-line: underline !important;
    text-decoration-thickness: 4px !important;
    text-decoration-color: rgb(0, 0, 0) !important;
    text-underline-offset: 22px !important;
    
    &:hover {
      text-decoration-line: underline !important;
      text-decoration-thickness: 4px !important;
      text-decoration-color: rgb(0, 0, 0) !important;
      text-underline-offset: 22px !important;
    }

  `
      : `color: ${colors.bksGray80} !important;`}

  ${theme.breakpoints.down('md')} {
    flex-flow: wrap;
    && span {
      display: none;
    }
  }
`

export const MenuBox = styled.div<{$isSideMenuExpanded?: boolean}>`
  background: #fff;
  position: absolute;
  z-index: 11;
  padding-top: 56px;
  transition:
    transform 0.5s ease,
    left 0.5s ease;
  ${({$isSideMenuExpanded}) =>
    $isSideMenuExpanded ? `left: 0;` : `left: -100%;`}
`

export const MenuIcon = styled.img`
  height: 16px;
`

export const StyledMenu = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
`

export const MenuItem = styled.div`
  font-size: 16px;
  color: ${colors.bksGray80};
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  cursor: pointer;

  &:hover {
    background-color: #e8f3fd;
    font-weight: bold;
  }
`

export const Divider = styled.div`
  background-color: ${colors.bksGray50};
  height: 1px;
  width: 100%;
`

export const LoginBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 164px;
  cursor: pointer;
  height: 100%;
  font-size: 14px;
  border-left: 1px solid ${colors.bksGray80};
  font-weight: bold;

  ${theme.breakpoints.down('md')} {
    width: 64px;
    border-left: 0;
  }
`
